import { useState } from "react"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"

import { MRT_Row } from "material-react-table"
import { download, generateCsv, mkConfig } from "export-to-csv"

import { TableRatingsReport } from "../surveyTypes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardExportButton } from "../../../../../shared/components/table/StandardExportButton"
import { useDateTime } from "../../../../localization/useDateTime"

interface DropdownExportButtonRatingsProps {
    rowsIsSelected: boolean
    containsRows: boolean
    allRowsWithFilter: MRT_Row<TableRatingsReport>[]
    selectedRows: MRT_Row<TableRatingsReport>[]
    chosenStartDate: string
    chosenEndDate: string
}

export const DropdownExportButtonRatings = ({
    allRowsWithFilter,
    rowsIsSelected,
    selectedRows,
    containsRows,
    chosenStartDate,
    chosenEndDate,
}: DropdownExportButtonRatingsProps) => {
    const dateTimeFactory = useDateTime()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-ratings-${chosenStartDate}_${chosenEndDate}`,
    })

    const handleExportRows = (rows: MRT_Row<TableRatingsReport>[]) => {
        const rowData = rows.map((row) => row.original)

        const exportRows = rowData.map((rating) => {
            const topics = rating.question.smiley.topics
                .map((rating) => rating.value)
                .sort()
                .join(", ")

            return {
                From: rating.startDate,
                To: rating.endDate,
                "Rating id": rating.id,
                "Survey name": rating.survey.title,
                Question: rating.question.title,
                Smiley: rating.question.smiley.value,
                Topics: topics,
                Comment: rating.question.smiley.comment ?? "",
                "Rating timestamp": dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(rating.created)),
            }
        })

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return (
        <div>
            <StandardExportButton onClick={handleClick} />

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <LocalizedStrict id="export-button-export-all-with-filter">
                    <MenuItem disabled={containsRows} onClick={() => handleExportRows(allRowsWithFilter)}>
                        Export all with filter
                    </MenuItem>
                </LocalizedStrict>
                <LocalizedStrict id="export-button-export-selected-rows">
                    <MenuItem disabled={rowsIsSelected} onClick={() => handleExportRows(selectedRows)}>
                        Export Selected rows
                    </MenuItem>
                </LocalizedStrict>
            </Menu>
        </div>
    )
}
